import {getDeclension} from "./utils/common";

const timer = () => {
  const timers = document.querySelectorAll(`.js-timer`);

  if (timers.length) {
    timers.forEach((timer) => {
      const newYear = new Date(timer.dataset.stockTimer);

      const daysValue = timer.querySelector(".js-value-days");
      const hoursValue = timer.querySelector(".js-value-hours");
      const minutesValue = timer.querySelector(".js-value-minutes");
      const secondsValue = timer.querySelector(".js-value-seconds");

      const daysText = timer.querySelector(".js-text-days");
      const hoursText = timer.querySelector(".js-text-hours");
      const minutesText = timer.querySelector(".js-text-minutes");
      const secondsText = timer.querySelector(".js-text-seconds");

      const timeCount = () => {
        const now = new Date();
        const leftUntil = newYear - now;

        const days = Math.floor(leftUntil / 1000 / 60 / 60 / 24);
        const hours = Math.floor(leftUntil / 1000 / 60 / 60) % 24;
        const minutes = Math.floor(leftUntil / 1000 / 60) % 60;
        const seconds = Math.floor(leftUntil / 1000) % 60;

        const addZeroToValue = (value) => (value < 10 ? `0${value}` : value);

        daysValue.textContent = addZeroToValue(days);
        hoursValue.textContent = addZeroToValue(hours);
        minutesValue.textContent = addZeroToValue(minutes);
        secondsValue.textContent = addZeroToValue(seconds);

        daysText.textContent = getDeclension(days, ["день", "дня", "дней"]);
        hoursText.textContent = getDeclension(hours, ["час", "часа", "часов"]);
        minutesText.textContent = getDeclension(minutes, ["минута", "минуты", "минут"]);
        secondsText.textContent = getDeclension(seconds, ["секунда", "секунды", "секунд"]);
      };

      timeCount();
      setInterval(timeCount, 1000);
    });
  }
};

export default timer;
